module.exports = __webpack_public_path__ + "img/blinds.77a3ce58.svg";